import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';
import _classes from './classes';
import _courses from './courses';
import _hours from './hours';
import _lessons from './lessons';
import _rooms from './rooms';
import _schoolYears from './school-years';
import _substitutionPlans from './substitution-plans';
import _teachers from './teachers';

export default (
  schedule: CoreTypes.Mixed.Schedule,
  options:  SduiTypes.options = {}
): SduiTypes.schedule => {
  return {
    schoolYear:        _schoolYears(schedule.divisions, options),
    classes:           schedule.groups?.map(x => _classes(x, options)),
    courses:           schedule.courses?.map(x => _courses(x, options)),
    // holidays:   schedule.holidays?.map(_holidays),
    hours:             [_hours(schedule.settings, options)],
    lessons:           schedule.events?.map(x => _lessons(x, options)),
    rooms:             schedule.locations?.map(x => _rooms(x, options)),
    // subjects:   schedule.subjects?.map(_subjects),
    substitution_plan: _substitutionPlans(schedule.exceptions, options),
    teachers:          schedule.teachers?.map(x => _teachers(x, options)),
  };
};
